// extracted by mini-css-extract-plugin
export default {"wrap":"Loading_wrap__6nvEl"};